import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../../store";
import { User, Activity, File } from "../../../api/classes";
import { Avatar, Typography, CardMedia, Card } from "@material-ui/core";
import * as moment from "moment";
import FileIcon from "@material-ui/icons/Attachment";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // This only needs to be imported once in your app
import "./lightbox.css";
import { DEFAULT_AVATAR } from "src/auth/auth";
interface Props {
  user: User;
  file: File;
  card?: boolean;
}
class CaseFile extends React.Component<Props> {
  state = {
    isLightBoxOpen: false
  };
  render() {
    const { file, user } = this.props;
    const inside = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginTop: 16,
          marginBottom: 16
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            {this.renderFiles()}
            {this.state.isLightBoxOpen && (
              <Lightbox
                mainSrc={this.imageUrl}
                onCloseRequest={() => this.setState({ isLightBoxOpen: false })}
              />
            )}
          </div>
        </div>
      </div>
    );
    if (!this.props.card) {
      return inside;
    }
    return (
      <Card
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: 16,
          maxWidth: 450,
          padding: 16,
          marginBottom: 16
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: 16,
            marginBottom: 16,
            alignItems: "center"
          }}
        >
          <Avatar
            style={{ width: 20, height: 20 }}
            src={
              user && user.account_picture
                ? user.account_picture
                : DEFAULT_AVATAR
            }
          />
          <Typography style={{ marginLeft: 8, fontSize: 13 }} variant="body2">
            {user && user.name}
          </Typography>
          <Typography style={{ marginLeft: 8 }} variant="caption">
            {moment(file.created_at).format("LLL")}
          </Typography>
        </div>
        {inside}
      </Card>
    );
  }
  get imageUrl() {
    if (!this.props.file.file_url.startsWith("http")) {
      return (
        "https://dubito.s3.eu-central-1.amazonaws.com/" +
        this.props.file.file_url
      );
    }
    if (this.props.file.file_url.startsWith("https://ton.twitter.com/")) {
      return "http://api.dubito.co/dmimage?url=" + this.props.file.file_url;
    }
    return this.props.file.file_url;
  }
  get fileURL() {
    if (!this.props.file.file_url.startsWith("http")) {
      return (
        "https://dubito.s3.eu-central-1.amazonaws.com/" +
        this.props.file.file_url
      );
    }
    return this.props.file.file_url;
  }
  renderFiles() {
    const { file } = this.props;
    if (this.props.file.file_type === "image") {
      return (
        <div style={{}}>
          {/*   <FileIcon />
        <Typography
          style={{
            marginLeft: 8,
            fontSize: 13,
            overflowWrap: "break-word",
            wordBreak: "break-all"
          }}
          variant="body2"
        >
          {this.props.file.file_type + "-" + this.props.file.file_url}
        </Typography> */}
          <img
            onClick={() => this.setState({ isLightBoxOpen: true })}
            style={{
              maxHeight: 300,
              maxWidth: "100%",
              objectFit: "contain"
            }}
            src={this.imageUrl}
            title="Contemplative Reptile"
          />
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FileIcon />
          <a target="_blank" href={this.fileURL}>
            <Typography
              style={{
                marginLeft: 8,
                fontSize: 13,
                overflowWrap: "break-word",
                wordBreak: "break-all"
              }}
              variant="body2"
            >
              {file.file_url.lastIndexOf("/") > -1
                ? file.file_url.substring(file.file_url.lastIndexOf("/") + 1)
                : file.file_url}
            </Typography>
          </a>
        </div>
      );
    }
  }
}
function mapStateToProps(state: GlobalState, own: Props) {
  return {
    user:
      state.cases.users &&
      state.cases.users.find(u => u.id === own.file.user_id)
  };
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseFile);



// WEBPACK FOOTER //
// ./src/pages/cases/components/file.tsx